<template>
  <section class="about-scenes">
    <div class="about-scenes__content">
      <AboutPageHeadline
        title="こんな時におすすめ"
        sub-title="受け取る相手はgifteeへの会員登録が不要です"
      />
      <div class="about-scenes__examples">
        <div class="about-scenes__example">
          <div class="about-scenes__example-texts">
            <h3 class="about-scenes__example-title title-bold">
              誕生日など大切な記念日に
            </h3>
            <p class="about-scenes__example-text">
              当日でもその場ですぐに贈れます
            </p>
          </div>
          <ImgLazy
            :image-url="AnniversaryImage"
            alt-text=""
            aspect-ratio="64 / 33"
            image-class="about-scenes__example-image"
          />
        </div>
        <div class="about-scenes__example">
          <div class="about-scenes__example-texts">
            <h3 class="about-scenes__example-title title-bold">
              同僚への差し入れに
            </h3>
            <p class="about-scenes__example-text">
              <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
              <span>コーヒー1杯など、</span><span>相手に気を遣わせずに贈れます</span>
            </p>
          </div>
          <ImgLazy
            :image-url="SashiireImage"
            alt-text=""
            aspect-ratio="64 / 33"
            image-class="about-scenes__example-image"
          />
        </div>
        <div class="about-scenes__example">
          <div class="about-scenes__example-texts">
            <h3 class="about-scenes__example-title title-bold">
              結婚や出産のお祝いに
            </h3>
            <p class="about-scenes__example-text">
              お祝いにぴったりのフォーマルなギフトも
            </p>
          </div>
          <ImgLazy
            :image-url="FormalImage"
            alt-text=""
            aspect-ratio="64 / 33"
            image-class="about-scenes__example-image"
          />
        </div>
        <div class="about-scenes__example">
          <div class="about-scenes__example-texts">
            <h3 class="about-scenes__example-title title-bold">推し活に</h3>
            <p class="about-scenes__example-text">
              住所など個人情報を伝えずに贈れます
            </p>
          </div>
          <ImgLazy
            :image-url="OshikatsuImage"
            alt-text=""
            aspect-ratio="64 / 33"
            image-class="about-scenes__example-image"
          />
        </div>
        <div class="about-scenes__example">
          <div class="about-scenes__example-texts">
            <h3 class="about-scenes__example-title title-bold">
              離れて暮らす家族のサポートに
            </h3>
            <p class="about-scenes__example-text">
              <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
              <span>食事券やごちそうグルメで、</span><span>健康的な食生活を応援できます</span>
            </p>
          </div>
          <ImgLazy
            :image-url="SupportImage"
            alt-text=""
            aspect-ratio="64 / 33"
            image-class="about-scenes__example-image"
          />
        </div>
        <div class="about-scenes__example">
          <div class="about-scenes__example-texts">
            <h3 class="about-scenes__example-title title-bold">
              イベントのスマートな景品に
            </h3>
            <p class="about-scenes__example-text">
              <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
              <span>URLを送るだけなので大人数でも</span><span>カンタンに配布できます</span>
            </p>
          </div>
          <ImgLazy
            :image-url="EventImage"
            alt-text=""
            aspect-ratio="64 / 33"
            image-class="about-scenes__example-image"
          />
        </div>
      </div>
      <AboutPageSeeMoreButton text="シーンからギフトを選ぶ" href="/scenes" />
    </div>
  </section>
</template>

<script setup>
import ImgLazy from '../../../atoms/images/ImgLazy.vue'
import AboutPageHeadline from '../../../atoms/headlines/AboutPageHeadline.vue'
import AnniversaryImage from '../../../../../../images/abouts/scnenes/01_anniversary.png'
import SashiireImage from '../../../../../../images/abouts/scnenes/02_sashiire.png'
import FormalImage from '../../../../../../images/abouts/scnenes/03_formal.png'
import OshikatsuImage from '../../../../../../images/abouts/scnenes/04_oshikatsu.png'
import SupportImage from '../../../../../../images/abouts/scnenes/05_support.png'
import EventImage from '../../../../../../images/abouts/scnenes/06_event.png'
import AboutPageSeeMoreButton from '../../../molecules/buttons/AboutPageSeeMoreButton.vue'
</script>

<style lang="scss" scoped>
.about-scenes {
  background-color: $primary-lighten;
  display: flex;
  justify-content: center;

  &__content {
    padding: 96px 72px;
    display: flex;
    flex-direction: column;
    gap: 48px;
    max-width: 1440px;
    width: 100%;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 64px 24px;
      gap: 24px;
    }
  }

  &__examples {
    display: grid;
    max-width: 1440px;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;

    @media all and (max-width: ($pc-width - 1)) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      grid-template-columns: 1fr;
    }
  }

  &__example {
    padding: 32px 16px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap: 24px;
    background-color: $white;
    border-radius: 32px;

    &-texts {
      display: flex;
      flex-direction: column;
      gap: 16px;

      @media all and (max-width: ($pc-width - 1)) {
        gap: 8px;
      }
    }

    &-text {
      @extend %module-text;
      color: $gray-1;

      > span {
        white-space: nowrap;

        @media all and (max-width: ($pc-width - 1)) {
          display: block;
        }
      }
    }

    &-image {
      max-width: 100%;
      height: auto;
      object-fit: contain;
    }
  }
}
</style>
